import supabase from "artifact/supabase";
import connected from "standard/connected";
import define from "standard/define";
import on from "standard/on";
import paint from "standard/paint";
import trait from "standard/trait";
import willPaint from "standard/willPaint";
import style from "./style";

@define("m-avatar-profile")
class AvatarProfile extends HTMLElement {
  #avatar = "";
  #url = `https://hzinyrqqkeqizojcotoj.supabase.co/storage/v1/object/public/avatars/${this.dataset.user}`;

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @willPaint
  async [trait.fetch]() {
    await fetch(
      `https://hzinyrqqkeqizojcotoj.supabase.co/storage/v1/object/public/avatars/${this.dataset.user}`,
    ).then((result) => {
      if (result.status === 400) {
        this.#avatar = "//donna.sistemadulino.com.br/avatar.jpeg";
        return this;
      }

      this.#avatar = this.#url;
    });
  }

  @connected
  @paint
  [trait.template]() {
    return `
      <label class="${style.avatar__container}">
        <img class="${style.avatar}" alt="Avatar" loading="eager" src="${this.#avatar}" />
        <label class="${style.avatar__label}" for="file">
          Alterar
          <input class="${style.avatar__input}" name="file" id="file" type='file' />
        </label>
      </label>
    `;
  }

  @on.change("input")
  async [trait.name](event) {
    const file = event.target.files[0];
    await supabase.storage.from("avatars").remove([this.dataset.user]);
    await supabase.storage.from("avatars").upload(this.dataset.user, file);
    location.reload();
    return this;
  }
}

export default AvatarProfile;
